import {
  faPlus,
  faTrash,
  faPen,
  faSave,
  faTimes,
  faTimesCircle,
  faSearch,
  faSync,
  faCog,
  faBars,
  faHome,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faExternalLinkAlt,
  faLink,
  faEnvelope,
  faComment,
  faComments,
  faPhone,
  faMobileAlt,
  faBell,
  faImage,
  faVideo,
  faVolumeUp,
  faPlay,
  faPause,
  faStop,
  faDownload,
  faUpload,
  faFile,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileArchive,
  faUser,
  faUsers,
  faSignInAlt,
  faSignOutAlt,
  faUserCircle,
  faLock,
  faUnlock,
  faKey,
  faShoppingCart,
  faShoppingBag,
  faTag,
  faTags,
  faCreditCard,
  faDollarSign,
  faEuroSign,
  faCalendar,
  faClock,
  faStopwatch,
  faSun,
  faMoon,
  faCloud,
  faCloudRain,
  faSnowflake,
  faWind,
  faDesktop,
  faLaptop,
  faTabletAlt,
  faPrint,
  faCamera,
  faStar,
  faHeart,
  faFlag,
  faBookmark,
  faInfoCircle,
  faQuestionCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faSpinner,
  faCheck,
  faXmark,
  faCircleCheck,
  faCircleXmark,
  faTriangleExclamation,
  faCircleExclamation,
  faEye,
  faEyeSlash,
  faCircleInfo,
  faSquare,
  faSquareCheck,
  faCircle,
  faCircleDot,
  faCaretDown,
  faCaretUp,
  faChevronDown,
  faChevronUp,
  faSort,
  faSortUp,
  faSortDown,
  faChartLine,
  faChartBar,
  faChartPie,
  faChartArea,
  faChartColumn,
  faMoneyBillTrendUp,
  faMoneyBill,
  faCoins,
  faPercent,
  faWallet,
  faBarsProgress,
  faListCheck,
  faBuilding,
  faUserTieHair,
  faMoneyBillTransfer,
  faChartLineUp,
  faLockOpen,
  faFileUser,
  faBadgeCheck,
} from "@fortawesome/pro-regular-svg-icons";

import { IconDefinition } from "@fortawesome/fontawesome-common-types";

// Map string keys to FontAwesome IconDefinitions
function getIcon(key: string): IconDefinition {
  const iconMap: Record<string, IconDefinition> = {
    // Common Actions
    add: faPlus,
    delete: faTrash,
    edit: faPen,
    save: faSave,
    cancel: faTimes,
    close: faTimesCircle,
    search: faSearch,
    refresh: faSync,
    settings: faCog,
    menu: faBars,

    // Navigation
    home: faHome,
    back: faArrowLeft,
    forward: faArrowRight,
    up: faArrowUp,
    down: faArrowDown,
    external: faExternalLinkAlt,
    link: faLink,

    // Communication
    email: faEnvelope,
    message: faComment,
    chat: faComments,
    phone: faPhone,
    mobile: faMobileAlt,
    notification: faBell,

    // Media
    image: faImage,
    video: faVideo,
    audio: faVolumeUp,
    play: faPlay,
    pause: faPause,
    stop: faStop,
    download: faDownload,
    upload: faUpload,

    // Documents
    file: faFile,
    pdf: faFilePdf,
    word: faFileWord,
    excel: faFileExcel,
    powerpoint: faFilePowerpoint,
    zip: faFileArchive,

    // Social - uncomment and add to @fortawesome/free-brands-svg-icons
    // to enable
    // 'facebook': faFacebook,
    // 'twitter': faTwitter,
    // 'instagram': faInstagram,
    // 'linkedin': faLinkedin,
    // 'youtube': faYoutube,
    // 'github': faGithub,

    // User Interface
    user: faUser,
    users: faUsers,
    login: faSignInAlt,
    logout: faSignOutAlt,
    profile: faUserCircle,
    lock: faLock,
    unlock: faUnlock,
    key: faKey,

    // Shopping
    cart: faShoppingCart,
    bag: faShoppingBag,
    tag: faTag,
    tags: faTags,
    "credit-card": faCreditCard,
    dollar: faDollarSign,
    euro: faEuroSign,

    // Date and Time
    calendar: faCalendar,
    clock: faClock,
    timer: faStopwatch,
    alarm: faBell,

    // Weather
    sun: faSun,
    moon: faMoon,
    cloud: faCloud,
    rain: faCloudRain,
    snow: faSnowflake,
    wind: faWind,

    // Devices
    desktop: faDesktop,
    laptop: faLaptop,
    tablet: faTabletAlt,
    printer: faPrint,
    camera: faCamera,

    // Misc
    star: faStar,
    heart: faHeart,
    flag: faFlag,
    bookmark: faBookmark,
    info: faInfoCircle,
    question: faQuestionCircle,
    warning: faExclamationTriangle,
    error: faExclamationCircle,
    success: faCheckCircle,
    loading: faSpinner,
    "list-check": faListCheck,

    // Form and Validation Icons
    check: faCheck,
    x: faXmark,
    "circle-check": faCircleCheck,
    "circle-x": faCircleXmark,
    alert: faTriangleExclamation,
    exclamation: faCircleExclamation,
    "show-password": faEye,
    "hide-password": faEyeSlash,
    "info-circle": faCircleInfo,

    // Form Controls
    checkbox: faSquare,
    "checkbox-checked": faSquareCheck,
    radio: faCircle,
    "radio-checked": faCircleDot,

    // Dropdown and Sorting
    "caret-down": faCaretDown,
    "caret-up": faCaretUp,
    "chevron-down": faChevronDown,
    "chevron-up": faChevronUp,
    sort: faSort,
    "sort-up": faSortUp,
    "sort-down": faSortDown,

    // Financial and Charts
    "chart-line": faChartLine,
    "chart-bar": faChartBar,
    "chart-pie": faChartPie,
    "chart-area": faChartArea,
    "chart-column": faChartColumn,
    building: faBuilding,
    "money-trend": faMoneyBillTrendUp,
    "money-bill": faMoneyBill,
    coins: faCoins,
    percent: faPercent,
    wallet: faWallet,

    // Progress Bar
    "bars-progress": faBarsProgress,

    // Misc additions
    "user-tie-hair": faUserTieHair,
    "money-bill-transfer": faMoneyBillTransfer,
    "chart-line-up": faChartLineUp,
    "lock-open": faLockOpen,
    "file-user": faFileUser,
    "badge-check": faBadgeCheck,
  };

  // Normalize the input key
  const normalizedKey = key.toLowerCase().trim();

  // Return the IconDefinition if found, otherwise return a default icon
  return iconMap[normalizedKey] || faQuestionCircle;
}

export default getIcon;
